import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Command } from '../../../core/model/command';
import { ICommandHandler } from '../../../core/service/command/command-handler-resolver.service';
import { Observable, of } from 'rxjs';
import { NavigationService } from '../../../core/service/navigation.service';
import { InvoiceReminderService } from '../data/invoice-reminder.service';
import { InvoiceReminder } from '../../model/invoice-reminder';
import { InvoiceReminderCommand } from '../../command/invoice-reminder';
import { NativeWindowService } from '../../../core/service/native-window.service';
import { InvoiceService } from '../data/invoice.service';

@Injectable()
export class PreviewInvoiceReminderCommandHandler implements ICommandHandler {
  constructor(
    private _service: InvoiceService,
    private _nativeWindow: NativeWindowService
  ) {}

  canExecute(command: Command): boolean {
    if (!command || !command.context) return false;
    return command.id == InvoiceReminderCommand.previewReminder;
  }

  execute(command: Command): Observable<void> {
    if (command instanceof Command) {
      return this.previewInvoiceReminderPDF(command.context.id);
    }
  }

  private previewInvoiceReminderPDF(itemId: string): Observable<void> {
    const tab = this._nativeWindow.openTab();
    return this._service.getReminderPdf(itemId).pipe(map(res => this._nativeWindow.openFile(res, `${itemId}.pdf`, tab)));
  }
}
